import { ValoresPorSabor } from "src/app/shared/components/integracao-pizza-lasanha/integracao-pizza-lasanha.viewmodel";

export class PizzaLasanhaGrid {
    public sabor: string = '';
    public tipoProduto: 'PIZZA' | 'LASANHA' = 'PIZZA';
    public ativo: boolean = false;
    public processando: boolean = false;
    public tamanhos: ValoresPorSabor[] = [];
    public usarPrecoPromocional: boolean = false;
}

